import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-people-selected",
  "use": "icon-people-selected-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-people-selected\">\r\n  <g id=\"icon-people-selected_组_88\" data-name=\"组 88\" transform=\"translate(-12 -446)\">\r\n    <circle id=\"icon-people-selected_椭圆_23\" data-name=\"椭圆 23\" cx=\"12\" cy=\"12\" r=\"12\" transform=\"translate(12 446)\" fill=\"#459fff\" />\r\n    <path id=\"icon-people-selected_路径_12034\" data-name=\"路径 12034\" d=\"M4862.128,2738.635l3.87,3.869,6.729-6.864\" transform=\"translate(-4843.428 -2281.073)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/people-selected.svg
// module id = dtji
// module chunks = 3